/* LL: shared non-modal offer/BYO regions; delegated events cover Local sticky clones. */
(() => {
  if (window.LLOfferPanel) { window.LLOfferPanel.init(); return; }
  const panels = [
    ['LLHeaderOfferPanel', '.ll-nav-promo a'],
    ['LLHeaderByoPanel', '.site-nav a[href*="/collections/build-your-own-meals"], .header-container a[href*="/collections/build-your-own-meals"]']
  ];
  const selector = panels.map(([, selector]) => selector).join(', ');
  const panelFor = link => document.getElementById(panels.find(([, selector]) => link.matches(selector))?.[0]);
  const desktop = matchMedia('(min-width:990px)');
  const hover = matchMedia('(min-width:990px) and (hover:hover)');
  let panel, trigger, openTimer, closeTimer, restoring = false, suppressed = false;
  const isTrigger = node => node instanceof Element && !node.closest('#site-menu-sidebar') && node.closest(selector);
  const inside = node => node instanceof Element && (panel?.contains(node) || isTrigger(node));
  const sync = () => document.querySelectorAll(selector).forEach(link => {
    const target = panelFor(link);
    if (target && desktop.matches && !link.closest('#site-menu-sidebar')) {
      link.setAttribute('aria-controls', target.id);
      link.setAttribute('aria-expanded', String(!target.hidden));
    } else {
      link.removeAttribute('aria-controls');
      link.removeAttribute('aria-expanded');
    }
  });
  const position = () => {
    if (!panel || panel.hidden) return;
    const header = trigger?.closest('.sticky-header, #site-header') || document.querySelector('#site-header');
    panel.style.setProperty('--ll-offer-top', `${Math.max(0, header?.getBoundingClientRect().bottom || 0)}px`);
  };
  const close = (restore = false) => {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (!panel) return;
    panel.hidden = true; sync();
    if (restore && trigger?.isConnected) {
      suppressed = true; restoring = true;
      trigger.focus({preventScroll:true});
      restoring = false;
    }
  };
  const open = link => {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (!desktop.matches || !link?.isConnected) return;
    const target = panelFor(link);
    if (!target) return;
    if (panel && panel !== target) panel.hidden = true;
    panel = target;
    window.LLShopPanel?.close(false, true);
    trigger = link; panel.hidden = false; position(); sync();
  };
  const init = () => { close(); panel = null; sync(); };
  window.LLOfferPanel = {init, close};
  document.addEventListener('pointerover', event => {
    if (!hover.matches || event.pointerType === 'touch') return;
    if (inside(event.target)) clearTimeout(closeTimer);
    const link = isTrigger(event.target);
    if (link && !suppressed && !link.contains(event.relatedTarget)) {
      clearTimeout(openTimer); openTimer = setTimeout(() => open(link), 120);
    }
  });
  document.addEventListener('pointermove', () => { suppressed = false; }, {passive:true});
  document.addEventListener('pointerout', event => {
    if (!hover.matches || event.pointerType === 'touch') return;
    const link = isTrigger(event.target);
    if (link && !link.contains(event.relatedTarget)) clearTimeout(openTimer);
    if (inside(event.target) && !inside(event.relatedTarget)) {
      clearTimeout(closeTimer); closeTimer = setTimeout(() => close(), 200);
    }
  });
  document.addEventListener('focusin', event => {
    if (restoring) return;
    const link = isTrigger(event.target);
    if (link) open(link);
    else if (!inside(event.target)) close();
    else clearTimeout(closeTimer);
  });
  document.addEventListener('click', event => { if (!inside(event.target)) close(); });
  const links = () => [...panel.querySelectorAll('a[href],button')].filter(n => n.getClientRects().length && !n.disabled);
  document.addEventListener('keydown', event => {
    if (!panel || panel.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(true); }
    if (event.key !== 'Tab') return;
    const items = links();
    if (event.target === trigger && !event.shiftKey) { event.preventDefault(); items[0]?.focus(); }
    else if (event.target === items[0] && event.shiftKey) {
      event.preventDefault(); restoring = true; trigger?.focus(); restoring = false;
    } else if (event.target === items.at(-1) && !event.shiftKey) {
      // Resume the page's normal focus sequence immediately after the originating pill.
      const sequence = [...document.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(n => n.getClientRects().length && !n.disabled && !n.closest('[hidden],[inert]') && !panel.contains(n));
      const next = sequence[sequence.indexOf(trigger) + 1];
      if (next) { event.preventDefault(); close(); next.focus(); }
      else close();
    } else if (event.target === trigger && event.shiftKey) close();
  });
  desktop.addEventListener('change', () => { close(); sync(); });
  let positionFrame = 0;
  const queuePosition = () => {
    if (!panel || panel.hidden || positionFrame) return;
    positionFrame = requestAnimationFrame(() => { positionFrame = 0; position(); });
  };
  window.addEventListener('resize', queuePosition, {passive:true});
  window.addEventListener('scroll', queuePosition, {passive:true});
  window.addEventListener('pagehide', () => close());
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => { close(); init(); });
  document.addEventListener('ll:header:updated', sync);
  init();
})();
